import { Badge } from "@mantine/core";
import { COLORS } from "../../../constants/colorConstants";

export default function CountBadge({ filteredCount, fetchCount, totalCount }) {
  let countLabel = `${filteredCount} visible | ${fetchCount} fetched | ${totalCount} total`;
  if (fetchCount === totalCount) {
    countLabel = `${filteredCount} visible | ${totalCount} total`;
  }

  return (
    <Badge size="md" variant="outline" c={COLORS.DARK_BROWN} bg={COLORS.WHEAT}>
      {countLabel}
    </Badge>
  );
}
